import { Table } from 'antd'
import React, { useEffect, useState } from 'react'
import { useKeyPressEvent } from 'react-use'

export default function CustTable (
  {
    dataSource, initColumns, height, rowKey, rowSelection, onRow,
    bordered, className, coloredRows, initSelectedRowId, expandable,
    style,
    showHeader = true,
    extraOnRow = () => { },
    rowClassName = () => { },
    updateContextOnSelect = (_) => { },
    pagination,
    tableLayout = 'fixed'
  }
) {
  rowKey = rowKey || ((record) => record?.id)

  const [selectedRow, setSelectedRow] = useState(
    dataSource?.find((e) => {
      return rowKey(e) === initSelectedRowId
    })
  )

  useEffect(() => {
    setColumns(initColumns.map((col) => ({
      ...col,
      onHeaderCell: (column) => ({
        width: column.width
      })
    })))
  }, [initColumns])

  const [columns, setColumns] = useState(
    initColumns.map((col) => ({
      ...col,
      onHeaderCell: (column) => ({
        width: column.width
      })
    }))
  )

  const rowClasses = (record, index) => {
    const classes = [rowClassName(record, index)]
    if (coloredRows) {
      classes.push((index % 2 === 0 ? 'table-row-light ' : 'table-row-dark '))
    }
    if (rowKey(record) === rowKey(selectedRow)) { classes.push('table-row-selected') }
    return classes.join(' ')
  }

  const onRowDefault = (record) => ({
    onClick: () => {
      if (record === selectedRow) { return }
      setSelectedRow(record)
      updateContextOnSelect(record)
      extraOnRow(record)
    }
  })

  const keyUp = () => {
    if (!selectedRow) { return }
    const record = dataSource[
      Math.max(0, dataSource.findIndex(e => e === selectedRow) - 1)]
    setSelectedRow(record)
    updateContextOnSelect(record)
  }

  const keyDown = () => {
    if (!selectedRow) { return }
    const record = dataSource[
      Math.min(dataSource.length - 1, dataSource.findIndex(e => e === selectedRow) + 1)
    ]
    setSelectedRow(record)
    updateContextOnSelect(record)
  }

  useKeyPressEvent('ArrowUp', keyUp)
  useKeyPressEvent('ArrowDown', keyDown)

  return (
    <Table
      style={style}
      virtual
      rowClassName={rowClasses}
      columns={columns}
      dataSource={dataSource}
      rowKey={rowKey}
      scroll={{ y: height, scrollToFirstRowOnChange: true }}
      size='small'
      rowSelection={rowSelection || null}
      bordered={bordered || true}
      className={className || ''}
      onRow={onRow || onRowDefault}
      showHeader={showHeader}
      expandable={expandable}
      pagination={pagination || false}
      tableLayout={tableLayout}
    />
  )
}
